import { useQuery } from "@tanstack/react-query";
import { fetchEcomodClasses } from "../api/ecomodClasses.api";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";

const useEcomodClasses = () => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["ecomodClasses"],
    queryFn: () => fetchEcomodClasses(bearerToken),
  });

  const fetchEcomodClassesData = async () => {
    await refetch();
  };

  return {
    ecomodClasses: data,
    error,
    isLoading,
    fetchEcomodClassesData,
  };
};

export default useEcomodClasses;
